import React from 'react';
import './_configurationBot.scss';
import { injectIntl } from 'react-intl';
import copilotIconSvg from '../../assets/images/copilotIcon.svg';
import bootupPageCopilotIconSvg from '../../assets/images/bootupPageCopilotIcon.svg';
import CapRow from '../../CapRow';
import CapImage from '../../CapImage';
import { IDENTITY_ICON_TYPES } from './constants';
import { getFullNameByFirstNameLastName } from '../util';

const IdentityIcon = ({
    iconType,
    firstName,
    lastName,
    classPrefixName,
    ...rest
}) => {
    return (
        <CapRow className={classPrefixName || "identity-icon-container"} {...rest}>
            {iconType === IDENTITY_ICON_TYPES.COPILOT && (
                <CapImage src={copilotIconSvg} />
            )}
            {iconType === IDENTITY_ICON_TYPES.BOOTUP_PAGE_BOT && (
                <CapImage src={bootupPageCopilotIconSvg} style={{width: "8rem"}} />
            )}
            {iconType === IDENTITY_ICON_TYPES.HUMAN && (
                <CapRow className="user-name-icon">
                    {getFullNameByFirstNameLastName({
                        firstName,
                        lastName,
                        fetchNameIntitialCharacters: true,
                    })}
                </CapRow>
            )}
        </CapRow>
    );
};

IdentityIcon.defaultProps = {};
export default injectIntl(IdentityIcon);
